import { useEffect, useState } from "react";

/**
 * Holds a value still for `delay` ms.
 *
 * Used on every search box. Without it, typing "copenhagen" is ten queries
 * against a table of 1,700 cafes with an ILIKE on three columns, nine of
 * whose results are thrown away before they render.
 */
export function useDebounced<T>(value: T, delay = 250): T {
  const [held, setHeld] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setHeld(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);
  return held;
}
